/**
 * Web Push (local) notifications for FlightSync.
 * Uses browser Notification API - no server push infrastructure required.
 *
 * Usage:
 *   await ensurePermission();
 *   notify('Sincronizado', 'Voo DJI Mavic 3 enviado ao servidor');
 */

export function notificationsSupported() {
  return typeof window !== 'undefined' && 'Notification' in window;
}

export async function ensurePermission() {
  if (!notificationsSupported()) return 'unsupported';
  if (Notification.permission === 'granted') return 'granted';
  if (Notification.permission === 'denied') return 'denied';
  try {
    const res = await Notification.requestPermission();
    return res;
  } catch {
    return 'denied';
  }
}

export function notify(title, body, opts = {}) {
  if (!notificationsSupported() || Notification.permission !== 'granted') return null;
  try {
    const n = new Notification(title, {
      body,
      icon: '/logo192.png',
      badge: '/logo192.png',
      tag: opts.tag || 'flightsync',
      silent: opts.silent || false,
      ...opts,
    });
    if (opts.onClick) n.onclick = opts.onClick;
    return n;
  } catch {
    return null;
  }
}
